import Vue from 'vue'
import VueRouter from 'vue-router'
import { getToken } from '@/utils/auth'
import { getAdminInfo } from '@/utils/auth'

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/login/index.vue'),
    meta: { title: '登录', noAuth: true }
  },
  {
    path: '/',
    component: () => import('@/components/Layout/index.vue'),
    redirect: '/dashboard',
    children: [
      { path: 'dashboard', name: 'Dashboard', component: () => import('@/views/dashboard/index.vue'), meta: { title: '数据总览', icon: 'el-icon-data-line' } },
      { path: 'users', name: 'UserList', component: () => import('@/views/users/list.vue'), meta: { title: '用户列表', icon: 'el-icon-user' } },
      { path: 'users/:id', name: 'UserDetail', component: () => import('@/views/users/detail.vue'), meta: { title: '用户详情' } },
      { path: 'courses', name: 'CourseList', component: () => import('@/views/courses/list.vue'), meta: { title: '课程列表', icon: 'el-icon-video-camera' } },
      { path: 'courses/create', name: 'CourseCreate', component: () => import('@/views/courses/edit.vue'), meta: { title: '新建课程' } },
      { path: 'courses/:id/edit', name: 'CourseEdit', component: () => import('@/views/courses/edit.vue'), meta: { title: '编辑课程' } },
      { path: 'courses/:id/episodes', name: 'CourseEpisodes', component: () => import('@/views/courses/episodes.vue'), meta: { title: '章节管理' } },
      { path: 'categories', name: 'Categories', component: () => import('@/views/categories/index.vue'), meta: { title: '课程分类', icon: 'el-icon-folder' } },
      { path: 'teachers', name: 'Teachers', component: () => import('@/views/teachers/index.vue'), meta: { title: '讲师管理', icon: 'el-icon-s-custom' } },
      { path: 'activities', name: 'ActivityList', component: () => import('@/views/activities/list.vue'), meta: { title: '活动列表', icon: 'el-icon-date' } },
      { path: 'activities/create', name: 'ActivityCreate', component: () => import('@/views/activities/edit.vue'), meta: { title: '新建活动' } },
      { path: 'activities/:id/edit', name: 'ActivityEdit', component: () => import('@/views/activities/edit.vue'), meta: { title: '编辑活动' } },
      { path: 'activities/:id/reservations', name: 'ActivityReservations', component: () => import('@/views/activities/reservations.vue'), meta: { title: '预约名单' } },
      { path: 'orders', name: 'OrderList', component: () => import('@/views/orders/list.vue'), meta: { title: '订单列表', icon: 'el-icon-shopping-cart-2' } },
      { path: 'orders/:id', name: 'OrderDetail', component: () => import('@/views/orders/detail.vue'), meta: { title: '订单详情' } },
      { path: 'interactions', name: 'InteractionList', component: () => import('@/views/interactions/list.vue'), meta: { title: '互动管理', icon: 'el-icon-chat-dot-round' } },
      { path: 'interactions/:userId/:courseId', name: 'InteractionChat', component: () => import('@/views/interactions/chat.vue'), meta: { title: '互动对话' } },
      { path: 'banners', name: 'Banners', component: () => import('@/views/banners/index.vue'), meta: { title: '轮播图管理', icon: 'el-icon-picture' } },
      { path: 'membership', name: 'Membership', component: () => import('@/views/membership/index.vue'), meta: { title: '会员等级', icon: 'el-icon-medal' } },
      { path: 'admins', name: 'Admins', component: () => import('@/views/admins/index.vue'), meta: { title: '管理员管理', icon: 'el-icon-setting', superOnly: true } },
      { path: 'logs', name: 'Logs', component: () => import('@/views/logs/index.vue'), meta: { title: '操作日志', icon: 'el-icon-document', superOnly: true } },
      { path: 'configs', name: 'Configs', component: () => import('@/views/configs/index.vue'), meta: { title: '系统配置', icon: 'el-icon-s-tools', superOnly: true } }
    ]
  },
  { path: '*', redirect: '/' }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  if (to.meta && to.meta.noAuth) {
    next()
    return
  }
  const token = getToken()
  if (!token) {
    next('/login')
    return
  }
  next()
})

export default router
